import axios, { CancelToken } from 'axios';
import { getToken } from "../../../token";
import {
    urlAcessosContratoDias,
    urlAcessosUsuario,
    urlContratoAtivos,
    urlUsersStatusTodos,
} from "../../../request/urls";

interface IFiltroDatasParams {
    inicio?: string;
    fim?: string;
}

class AcessosUsuarioService {

    async getAcessosPorUsuario(
        usuarioId: number,
        params?: IFiltroDatasParams,
        signal?: CancelToken,
    ) {
        const { data } = await axios.get(urlAcessosUsuario(usuarioId), {
            headers: { 'Authorization': 'Bearer ' + getToken() },
            cancelToken: signal,
            params,
        });

        return data;
    }

    async getAcessosPorContratoDias(
        contratoId: number,
        params?: IFiltroDatasParams,
        signal?: CancelToken,
    ) {
        const { data } = await axios.get(urlAcessosContratoDias(contratoId), {
            headers: { 'Authorization': 'Bearer ' + getToken() },
            cancelToken: signal,
            params,
        });

        return data;
    }

    async getUsuariosStatusTodos(signal?: CancelToken) {
        const { data } = await axios.get(urlUsersStatusTodos, {
            headers: { 'Authorization': 'Bearer ' + getToken() },
            cancelToken: signal,
        });

        return data;
    }

    async getContratosAtivos(signal?: CancelToken) {
        const { data } = await axios.get(urlContratoAtivos, {
            headers: { 'Authorization': 'Bearer ' + getToken() },
            cancelToken: signal,
        });

        return data;
    }
}

export default new AcessosUsuarioService();
